import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter, IonIcon } from '@ionic/react';
import Navbar from '../../components/Navbar';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";
import { arrowForwardCircle } from 'ionicons/icons';
import axios from 'axios';
import './styles.css';
import MonthlyTypeEnum from '../../enum/monthly-type-enum';
import { MonthlyDataHelper } from '../../services/monthly-data-helper';

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const isEscWorks = CurrentUser ? CurrentUser.isEscWorks : false;
  const groupName = CurrentUser ? CurrentUser.group : '';
  
  const currentYear = GetCurrentYear() - 2000;
  let current_year = currentYear + '-' + (currentYear + 1);
  let previous_year = (currentYear - 1) + '-' + currentYear;

  const currentFullYear = GetCurrentYear();
  let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
  let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

  const dataUrl = `${ServerUrl}/quaterly/2.5`;
  const dataSubmittedUrl = `${ServerUrl}/quaterly/2.5/Submitted`;

  const data = [
    { name: "September - November" },
    { name: "December - February" },
    { name: "March - May" },
    { name: "June - August" },
  ];

  const [MonthRowStates, SetMonthRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
    { name: "September - November", isEqualSum: true },
    { name: "December - February", isEqualSum: true },
    { name: "March - May", isEqualSum: true },
    { name: "June - August", isEqualSum: true }
  ]);

  const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
  const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

  const [TotalNonEscWorksSum, SetTotalNonEscWorksSum] = useState<string>('');
  const [TotalEscWorksDashboardSum, SetTotalEscWorksDashboardSum] = useState<string>('');
  const [CurrentParticipantSum, SetCurrentParticipantSum] = useState<string>('0');
  const [CurrentEventSum, SetCurrentEventSum] = useState<string>('0');

  const [PreviousParticipantSum, SetPreviousParticipantSum] = useState<string>('0');
  const [PreviousEventSum, SetPreviousEventSum] = useState<string>('0');

  useIonViewDidEnter(() => {
    console.log('ionViewDidEnter event fired');
    LoadData();
  });

  const LoadData = () => {
    axios.get(`${dataUrl}?year=${current_year}`, {
        headers: {
          'Authorization': "Bearer " + token,          
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          SetCurrentData(res.data);
          SetCurrentParticipantSum(getSum(res.data, true));
          SetCurrentEventSum(getSum(res.data, false));
          SetTotalNonEscWorksSum(getSum(res.data, true, MonthlyTypeEnum.NonEscWorksData));
          SetTotalEscWorksDashboardSum(getSum(res.data, true, MonthlyTypeEnum.EscWorksDashboardData));
        
          setMonthRawStates(res.data);
        }
    }, err => {
      alert("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${dataUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousData(res.data);
        SetPreviousParticipantSum(getSum(res.data, true));
        SetPreviousEventSum(getSum(res.data, false));
      }
  }, err => {
    console.log("Fail to get data. " + JSON.stringify(err))
  });
  };

  const getQuaterData = (dataArray: Array<any>, name: string, first: boolean, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default) => {
    let num = 0;
    let element = dataArray.find(e => e.quater === name);
    if (element) {
      var data = parseFloat(getDataByMontlyType(element, monthlyType, first));
        if (!isNaN(data)) {
          num = data;
        }
    }
    return num;
  }

  const setMonthRawStates = (inititalData: Array<any>) => {
    const yearDataArray = inititalData.filter(element => element.year === current_year);
    yearDataArray.forEach(monthData => {
      updateMonthRowStates(monthData.quater, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.participants);
    });
  }

  const updateNonEscEorksData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    saveData(year, month, value, current, monthlyType);

    updateMonthRowStates(month, year, value);
  }

  const isSumEqual = (allData: any[], month: string,  year: string, 
    nonEscWorksValue: any, escWorksDashboardValue: any = null, submittedValue: any = null) : boolean => 
  {
    const isParsed = MonthlyDataHelper.tryParseFloat(nonEscWorksValue);
    if (!isParsed){
      return true;
    }

    const floatNonEscWorksValue: number = isParsed.parsedValue;
    let floatEscWorksDashBoardValue: number;
    let floatSubmittedValue: number;
    if (escWorksDashboardValue != null) {
      floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(escWorksDashboardValue).parsedValue;
      floatSubmittedValue = MonthlyDataHelper.tryParseFloat(submittedValue).parsedValue;
    }
    else{
      const monthData = allData.find(element => element.year === year && element.quater == month);
      floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
      floatSubmittedValue = MonthlyDataHelper.tryParseFloat(monthData.participants).parsedValue;
    }

    return  floatNonEscWorksValue + floatEscWorksDashBoardValue == floatSubmittedValue;
  }

  const updateMonthRowStates = (month: string,  year: string, nonEscWorksValue: any, 
      escWorksDashboardValue: any = null, submittedValue: any = null) => {
    SetMonthRowStates(prevMonthState => {
      const newState = prevMonthState.map(prevMonth => {

        if (prevMonth.name == month) {
          return {...prevMonth, isEqualSum: isSumEqual(CurrentData, month, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
        }

        return prevMonth;
      });

      return newState;
    });
  }

  const getDataByMontlyType = (element: any, monthlyType: MonthlyTypeEnum, forContacts: boolean) => {
    if (monthlyType == MonthlyTypeEnum.Default){
      return forContacts ? element.participants : element.events;
    }
    else if (monthlyType == MonthlyTypeEnum.NonEscWorksData){
      return element.nonEscWorksData;
    }
    else{
      return element.escWorksDashboardData;
    }
  }

  const getSum = (data: Array<any>, forContacts: boolean, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default): string => {
    let sum = 0;
    data.forEach(item => { 
      var data = parseFloat(getDataByMontlyType(item, monthlyType, forContacts))
      if (!isNaN(data)) {
        sum += data;
      }
    });

    return sum === 0 ? sum.toString() : sum.toLocaleString();
  }

  const saveData = (year: string, quater: string, value: any, forContacts: boolean,  monthlyType: MonthlyTypeEnum) => {
    axios.post(dataUrl, {"year": year, "quater": quater, "value": value, "forContacts": forContacts, "monthlyType": monthlyType}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (year === current_year) {
        SetCurrentData(res.data);
        SetCurrentParticipantSum(getSum(res.data, true));
        SetCurrentEventSum(getSum(res.data, false));
        SetTotalNonEscWorksSum(getSum(res.data, true, MonthlyTypeEnum.NonEscWorksData));
        SetTotalEscWorksDashboardSum(getSum(res.data, true, MonthlyTypeEnum.EscWorksDashboardData));
      } else {
        SetPreviousData(res.data);
        SetPreviousParticipantSum(getSum(res.data, true));
        SetPreviousEventSum(getSum(res.data, false));
      }
    }, err => console.log("error"));
  }

  const onSaveExcel = () => {
    axios.get(`${dataUrl}/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','Quarterly 2.5.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  const updateSubmittedData = (month: string) => {
    const monthData = CurrentData.find(element => element.year === current_year && element.quater == month);
    const floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
    const floatNonEscWorksValue = MonthlyDataHelper.tryParseFloat(monthData.nonEscWorksData).parsedValue;
    const updatedValue = floatEscWorksDashBoardValue + floatNonEscWorksValue

    axios.post(dataSubmittedUrl, {"quater": month, "value": updatedValue, "year": current_year}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      SetCurrentData(res.data);
      SetCurrentParticipantSum(getSum(res.data, true));
      SetCurrentEventSum(getSum(res.data, false));
      SetTotalNonEscWorksSum(getSum(res.data, true, MonthlyTypeEnum.NonEscWorksData));
      SetTotalEscWorksDashboardSum(getSum(res.data, true, MonthlyTypeEnum.EscWorksDashboardData));

      setMonthRawStates(res.data);
    })
  }

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
          <div className='content-container'>
            <div style={{marginBottom: '10px', marginTop: '20px'}}>{groupName}</div>
                  <div style={{ marginBottom: '20px' }}>Indicator 2.5 - Number of Individuals Participating in Learning Through Online Learning and the Number of Online Learning Events</div>
            <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSaveExcel}>Export to Excel</IonButton>
          </div>
          <div className='flex-container'>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="6" size="4" className='data-row right-border bottom-border table-header'>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row-bottom">
                  <IonCol className='no-border'>Reporting Period</IonCol>
                  <IonCol size="auto" style={{fontSize: '14px', display:'none'}} className='data-row'>
                    <IonInput  style={{width: '140px'}} min='0'  value="Non-escWorks Data" readonly />
                  </IonCol>
                  <IonCol size="auto" style={{fontSize: '14px', display: 'none'}} className='data-row'>
                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                  </IonCol>
                  {/*<IonCol className='data-row right-border'>*/}
                  {/*  <IonInput min='0' value="Participants" readonly />*/}
                  {/*</IonCol>*/}
                  {/*<IonCol className='data-row right-border'>*/}
                  {/*  <IonInput min='0'  value="Events" readonly />*/}
                              {/*</IonCol>*/}
                              <IonCol className='no-border'>Participants</IonCol>
                              <IonCol className='no-border'>Events</IonCol>
                </IonRow>
                {MonthRowStates.map((state, index) => {
                  if (state.isEqualSum){
                    return (
                      <div style={{display:'flex'}} key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                        <IonCol className='data-row fixed-width'><IonInput min='0'  value={state.name} readonly /></IonCol>
                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                          <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, true, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                              updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                            }}>     
                          </IonInput>
                        </IonCol>
                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                          <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getQuaterData(CurrentData, state.name, true, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                              //saveTotalData(name, e.target.value, current_year, true);
                            }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row'>
                          <IonInput min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, true)} placeholder="" onBlur={(e) => {
                                saveData(current_year, state.name, e.target.value, true, MonthlyTypeEnum.Default)
                              }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row right-border'>
                          <IonInput min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, false)} placeholder="" onBlur={(e) => {
                                saveData(current_year, state.name, e.target.value, false, MonthlyTypeEnum.Default)
                          }}>     
                          </IonInput>
                        </IonCol>
                      </div>
                    )
                  }
                  else{
                    return(
                      <div style={{display:'flex'}} key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                        <IonCol className='data-row fixed-width'><IonInput min='0'  value={state.name} readonly /></IonCol>
                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                          <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, true, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                              updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                            }}>     
                          </IonInput>
                        </IonCol>
                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                          <IonInput min='0' readonly  type="number" step="1" value={getQuaterData(CurrentData, state.name, true, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                              //saveTotalData(name, e.target.value, current_year, true);
                            }}>     
                          </IonInput>
                          <IonButton fill="clear" onClick={() => updateSubmittedData(state.name)} className="arrow-button">
                            <IonIcon icon={arrowForwardCircle} />
                          </IonButton>
                        </IonCol>
                        <IonCol className='data-row'>
                          <IonInput min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, true)} placeholder="" onBlur={(e) => {
                                saveData(current_year, state.name, e.target.value, true, MonthlyTypeEnum.Default)
                              }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row right-border'>
                          <IonInput min='0'  type="number" step="1" value={getQuaterData(CurrentData, state.name, false)} placeholder="" onBlur={(e) => {
                                saveData(current_year, state.name, e.target.value, false, MonthlyTypeEnum.Default)
                          }}>     
                          </IonInput>
                        </IonCol>
                      </div>
                    )
                  }
                })}
                <IonRow>
                  <IonCol style={{ width: '140px'}}  className='data-row top-border'></IonCol>
                              <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px',  width: '140px'}}>
                      <IonInput value={TotalNonEscWorksSum} readonly />
                    </div>
                  </IonCol>
                              <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput value={TotalEscWorksDashboardSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={CurrentParticipantSum} readonly />
                    </div>  
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                                  <div style={{ paddingRight: '14px' }}>
                      <IonInput min='0'  value={CurrentEventSum} readonly />
                    </div>  
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="6" size="4" className='data-row right-border bottom-border table-header'>
                    <IonInput min='0'  value={previous_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row-bottom">
                  <IonCol className='no-border'>Reporting Period</IonCol>
                  <IonCol className='no-border'>Participants</IonCol>
                  <IonCol className='no-border'>Events</IonCol>
                </IonRow>
                {data.map((d, index) => {
                  return (
                    <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                      <IonCol className='data-row fixed-width'><IonInput min='0'  value={d.name} readonly /></IonCol>
                      <IonCol className='data-row'>
                        <IonInput min='0'  readonly type="number" step="1" value={getQuaterData(PreviousData, d.name, true)} placeholder="" onBlur={(e) => {
                              // saveData(previous_year, d.name, e.target.value, true)
                            }}>     
                        </IonInput>
                      </IonCol>
                      <IonCol className='data-row right-border'>
                        <IonInput min='0'  readonly type="number" step="1" value={getQuaterData(PreviousData, d.name, false)} placeholder="" onBlur={(e) => {
                              //saveData(previous_year, d.name, e.target.value, false)
                        }}>     
                        </IonInput>
                      </IonCol>
                    </IonRow>
                  )
                })}
                <IonRow>
                  <IonCol className='data-row top-border'></IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={PreviousParticipantSum} readonly />
                    </div> 
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={PreviousEventSum} readonly />
                    </div> 
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>

      </IonContent>
    </IonPage>
  );
};

export default Home;
